/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Colleague_Email_ButtonInputs */

const en_colleague_email_button = /** @type {(inputs: Colleague_Email_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email service desk`)
};

const ja_colleague_email_button = /** @type {(inputs: Colleague_Email_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サービスデスクにメール`)
};

const fr_colleague_email_button = /** @type {(inputs: Colleague_Email_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envoyer un e-mail au service desk`)
};

const de_colleague_email_button = /** @type {(inputs: Colleague_Email_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Service Desk mailen`)
};

/**
* | output |
* | --- |
* | "Email service desk" |
*
* @param {Colleague_Email_ButtonInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const colleague_email_button = /** @type {((inputs?: Colleague_Email_ButtonInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Colleague_Email_ButtonInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_colleague_email_button(inputs)
	if (locale === "ja") return ja_colleague_email_button(inputs)
	if (locale === "fr") return fr_colleague_email_button(inputs)
	return de_colleague_email_button(inputs)
});